var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.currentUser)?_c('div',{attrs:{"id":"editor"}},[_c('b-container',{attrs:{"fluid":""}},[_c('router-view',{attrs:{"name":"main"}})],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }